import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  display: flex;
  gap: 4rem;
  flex-wrap: wrap;
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 16rem;
`;

export const StyledSectionTitle = styled.h3`
  margin-bottom: 0.5rem;
  ${pickThemeFontStyles('14', '20')};
  color: ${COLORS.GREY_DARK};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: ${COLORS.BLACK_SECONDARY};
  gap: 1rem;
  margin-bottom: 0.4rem;
  ${pickThemeFontStyles('14', '20')};

  label {
    ${pickThemeFontStyles('14', '20')};
    color: ${COLORS.GREY_DARK};
  }
`;

export const StyledDashedLine = styled.div`
  flex: 1;
  border-bottom: 1px dashed ${COLORS.LIGHT_PURPLE};
  margin: 0 0.5rem;
  height: 1px;
`;

export const StyledValue = styled.span`
  ${pickThemeFontStyles('14', '20', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;
